<template>
  <modal @before-open="beforeOpen" @opened="opened" @close="close" @before-close="beforeClose" name="createNotice"
         :draggable="'.header'"
         :reset="true"
         :classes="['feedback','generalbox']" :adaptive="true" :pivotX="modalOffsetDistance.x"
         :pivotY="modalOffsetDistance.y"
         :height="'80%'" :width="'80%'" :max-width="1540" :max-height="885" :min-width="1092"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2>新建通知公告</h2>
    </div>
    <div class="content">

      <div class="fdblock link">
        <p>标题：</p>
        <input v-model="noticeTitle" class="linkway" type="text"/>
      </div>
      <div class="fdblock link selectNoticeSort">
        <p>类别：</p>
        <el-select size="small" multiple v-model="currNoticeSort" placeholder="请选择">
          <el-option
          v-for="item in noticeColumn"
          :key="item.noticeSort"
          :label="item.columnName"
          :value="item.noticeSort">
          </el-option>
        </el-select>
      </div>
      <div v-if="!previewPDFMode" class="fdblock selectPDFViewMode">
        <p>是否发送至企业微信：<i @click="toggleSendQywx" class="iconfont"
                        :class="sendQywx?'icon-duoxuankuang':'icon-bk-checkbox-copy'"></i></p>
      </div>
      <div v-if="sendQywx" class="fdblock pdfUpload">
        <p>上传企业微信消息封面图：</p>
        <div v-if="!qywxFengmian" @click="uploadPDFAction" class="inputBtn">
          <div class="btn">
            <i class="iconfont icon-24"></i>
            选择企业微信消息封面图
          </div>
          <input ref="uploadPDFBtn" @change="selectQywxFMImg" accept=".jpg" type="file"/>
        </div>
        <ul v-if="qywxFengmian" class="fileList">
          <li>
            <i class="iconfont icon-fujian"></i>
            <p>已上传企业微信消息封面图</p>
            <div @click="removeQywxFMImg" class="del"><i class="iconfont icon-cha"></i></div>
          </li>
        </ul>
      </div>
      <div v-if="!sendQywx" class="fdblock selectPDFViewMode">
        <p>设置为预览PDF模式：<i @click="togglePreviewPDFMode" class="iconfont"
                         :class="previewPDFMode?'icon-duoxuankuang':'icon-bk-checkbox-copy'"></i></p>
      </div>
      <div v-if="previewPDFMode" class="fdblock pdfUpload">
        <p>上传PDF：</p>
        <div v-if="!previewPDFInfo.name" @click="uploadPDFAction" class="inputBtn">
          <div class="btn">
            <i class="iconfont icon-24"></i>
            上传预览的PDF
          </div>
          <input ref="uploadPDFBtn" @change="selectPDF" accept=".pdf" type="file"/>
        </div>
        <ul v-if="previewPDFInfo.name" class="fileList">
          <li>
            <i class="iconfont icon-fujian"></i>
            <p>{{previewPDFInfo.name}}</p>
            <div @click="resetPDFFile" class="del"><i class="iconfont icon-cha"></i></div>
          </li>
        </ul>
      </div>

      <div v-if="!previewPDFMode" class="fdblock editor">
        <p>内容：</p>
        <editor ref="editor"></editor>
      </div>
      <div class="fdblock fileUpload">
        <p>附件：</p>
        <div v-if="filesList.length<filesMaxLength" @click="uploadAction" class="inputBtn">
          <div class="btn">
            <i class="iconfont icon-24"></i>
            上传文件
          </div>
          <input ref="uploadBtn" @change="selectFile" type="file"/>
        </div>
        <ul v-if="filesList.length" class="fileList">
          <li v-for="file in filesList">
            <i class="iconfont icon-fujian"></i>
            <p>{{file.name}}</p>
            <div @click="deleteFile(file)" class="del"><i class="iconfont icon-cha"></i></div>
          </li>
        </ul>
      </div>
      <div class="fdblock link">
        <p>发布日期：</p>
        <flatPickr v-model="publishTime" :config="flatPickerConfig"></flatPickr>
        <div class="selectPublishFor">
          <el-radio v-model="publishFor" label="0">发送至部门</el-radio>
          <el-radio v-model="publishFor" label="1">发送至人员</el-radio>
          <el-radio v-model="publishFor" label="2">发送至公共</el-radio>
          <el-radio v-model="publishFor" label="3">发送至标签组</el-radio>
        </div>
      </div>

      <div v-show="publishFor==='0' || publishFor==='1'" class="fdblock">

        <p>选择部门：</p>
        <el-tree
        :data="treeData"
        show-checkbox
        @check-change="checkDeptAction"
        ref="deptTree"
        >
        </el-tree>

      </div>

      <div v-show="publishFor==='1'" class="fdblock">
        <p>选择人员：</p>
        <div class="search">
          <input v-model="peopleKeyword" placeholder="请输入人员姓名搜索" type="text"/>
          <button @click="initPeople"><i class="iconfont icon-ai219"></i></button>
        </div>
        <p class="selectInfo">当前选择人数：{{selectPeople.length}}
          <button @click="clearSelectPeople" class="clearbtn">清空选择</button>
        </p>

        <ul class="peopleList">
          <li :title="people.remark" @click="toggleSelectState(people)" v-for="people in peopleList">
            <span v-if="selectPeople.indexOf(people.loginName)!==-1"><i class="iconfont icon-duigou"></i></span>
            {{people.userName}}
          </li>

        </ul>
        <v-pagination @page-change="peoplePageChange" @page-size-change="peoplePageSizeChange" :total="peopleCount"
                      :pageIndex="peoplePageIndex" :page-size="peoplePageSize"
                      :pageSizeOption="[20,40,60]"></v-pagination>
      </div>

      <div v-show="publishFor==='3'" class="fdblock">

        <p>选择标签：</p>

        <ul class="peopleList">
          <li @click="toggleSelectLabelState(labelItem)" v-for="labelItem in labelList">
            <span v-if="selectLabelList.indexOf(labelItem.id)>-1"><i
            class="iconfont icon-duigou"></i></span>
            {{labelItem.name}}
          </li>
        </ul>
      </div>

      <button @click="submitFeedback(2)" class="submitBtn">提交</button>
      <button @click="submitFeedback(0)" class="submitBtn">存草稿</button>
      <button @click="resetForm" class="submitBtn">重置</button>
    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  import multiselect from 'vue-multiselect';
  import flatPickr from 'vue-flatpickr-component';
  import {Mandarin} from 'flatpickr/dist/l10n/zh.js';
  //日期处理
  import {formatDate} from 'common/js/date.js'
  //通信总线
  import Bus from 'common/js/bus.js';
  //百度编辑器
  import editor from 'components/globalComp/editor'
  //lodash
  import _ from 'lodash'

  const FILES_MAX_LENGTH = 100

  export default {
    name: "createNotice",
    data() {
      return {

        //通知公告ID: 0 新建 n 草稿
        noticeId: 0,

        noticeColumn: [],
        currNoticeSort: [],
        //选择器配置
        flatPickerConfig: {
          enableTime: false,
          dateFormat: "Y-m-d",
          locale: Mandarin,
          defaultDate: new Date()
        },
        noticeTitle: null,
        noticeContent: null,
        publishTime: formatDate(new Date(), "yyyy-MM-dd"),

        //是否为预览PDF模式
        previewPDFMode: false,
        previewPDFInfo: {
          name: null,
          url: null
        },

        //选择部门or人: 0 部门 1 人 2 公共
        publishFor: "0",
        //部门树形菜单
        // 设置项
        options: {
          label: 'deptName',
          checkbox: true,
          checkedOpen: true,
          folderBold: false,
          idsWithParent: false,
          depthOpen: 1,
          openIcon: 'iconfont icon-iconjia',
          closeIcon: 'iconfont icon-iconjian',
          halfCheckedIcon: 'iconfont icon-xuanzhong1',
          checkedIcon: 'iconfont icon-xuanzhong',
          uncheckedIcon: 'iconfont icon-checkbox-o'
        },
        treeData: [],
        checkedIds: [],

        //人员
        peopleList: [],
        selectPeople: [],
        canRequestPeople: true,
        peoplePageIndex: null,
        peoplePageSize: 20,
        peopleCount: null,
        peopleKeyword: null,
        filesList: [],
        filesMaxLength: FILES_MAX_LENGTH,

        //是否发送至企业微信
        sendQywx: false,
        qywxFengmian: null,
        //标签
        labelList: [],
        selectLabelList: []
      }

    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        if (this.$route.path.indexOf("/home") !== -1) {
          this.$store.commit("toggleSideMenuShow", false);
        }
        this.resetForm()
        this.$modal.hide("createNotice");
      },
      beforeClose() {
        Bus.$emit("modalSlidesClose")

      },
      async beforeOpen(data) {


        //----------编辑流程-------------
        if (data.params.data) {
          if (!data.params.data.state) {
            let draftInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNotice?id=" + data.params.data.id)
            draftInfo = draftInfo.data.data[0];
            this.noticeId = draftInfo.id;
            this.noticeContent = draftInfo.content;
            this.noticeTitle = draftInfo.title;
            this.sendQywx = draftInfo.qywxSend;
            this.qywxFengmian = draftInfo.qywxCover
            this.previewPDFMode = draftInfo.showType === 'pdf' ? true : false

            if (this.previewPDFMode) {
              //pdf预览模式
              this.previewPDFInfo.name = draftInfo.filename
              this.previewPDFInfo.content = ''
            } else {
              //输入文本模式
              this.$refs.editor.setEditorContent(draftInfo.content)
            }


            draftInfo.attachmentlist.forEach((attachItem) => {
              let fileObj = {
                id: attachItem.id,
                content: draftInfo.domain + attachItem.filepath,
                url: attachItem.filepath,
                name: attachItem.filename,
              }
              this.filesList.push(fileObj)
            })
          }
        }


        //----------默认流程-------------
        this.$store.commit("toggleSideMenuShow", true);
        this.initDepts();
        setTimeout(() => {
          this.publishTime = formatDate(new Date(), "yyyy-MM-dd");
        }, 500);
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      resetForm() {
        this.noticeTitle = null;
        this.noticeContent = null;
        this.publishTime = formatDate(new Date(), "yyyy-MM-dd");
        this.filesList = []
        this.checkedIds = [];
        this.peopleList = [];
        this.selectPeople = [];
        this.publishFor = '0'

        this.currNoticeSort = []
        this.sendQywx = false
        this.qywxFengmian = false
        this.previewPDFMode = false
        this.previewPDFInfo.name = null
        this.previewPDFInfo.url = null
      },
      async submitFeedback(state) {
        if (this.previewPDFMode) {
          //如果是预览pdf模式
          if (!(this.previewPDFInfo.name)) {
            this.$notify({
              group: 'global',
              title: '温馨提示',
              text: '请先上传PDF文件再提交！',
            });
            return
          }
          this.noticeContent = ''

        } else {
          this.noticeContent = this.$refs.editor.getEditorContent()
          if (apiConfig.debug) {
            this.noticeContent = '跨域测试内容'
          }
          //如果是输入内容模式
          if (!this.noticeContent || this.noticeContent === "<p><br></p>") {
            this.$notify({
              group: 'global',
              title: '温馨提示',
              text: '请填写通知公告内容再提交！',
            });
            return
          }
          this.resetPDFFile()

        }
        if (!this.noticeTitle) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '发布内容和标题不能为空~',
          });
          return;
        }

        if (this.publishFor === "0" && !this.checkedIds.length) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '您还没有选择部门~',
          });
          return;
        }
        if (this.publishFor === "1" && !this.selectPeople.length) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '您还没有选择人员~',
          });
          return;
        }

        if (this.publishFor === "3" && !this.getLabelToString) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '您还没有选择标签组~',
          });
          return;
        }
        if (!this.currNoticeSort.length) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '必须选择类别才能发布！',
          });
          return
        }
        if (this.sendQywx && !this.qywxFengmian) {
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: '推送企业微信必须选择消息封面图！',
          });
          return
        }
        let requestOrg = this.checkedIds.join(",");
        let requestPeople = this.selectPeople.join(",");

        //用户输入异常处理
        switch (this.publishFor) {
          case "0":
            requestPeople = "";
            break;
          case "2":
            requestOrg = "";
            requestPeople = "";
            break;
          default:
            console.log("this.publishFor参数异常");
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        let sysId = null;
        let sysname = null;
        if (this.appName) {
          sysId = this.appName.appid;
          sysname = this.appName.name;
        }
        console.log(this.publishFor)
        if (this.publishFor === 1) {
          state = 1
        }
        let resp = await axios.post(apiConfig.REQUEST_URL + "/shall/front_addNotice", {
          id: this.noticeId,
          title: this.noticeTitle,
          content: this.noticeContent,
          time: this.publishTime,
          orgid: requestOrg,
          uuid: requestPeople,
          state: state,
          labelId: this.getLabelToString,
          type: this.getTypeIdByPublishFor(),
          //pdf文档
          filename: this.previewPDFInfo.name,
          fileids: this.previewPDFInfo.url,
          filepath: this.previewPDFInfo.url,
          file: this.previewPDFInfo.url,
          showType: this.previewPDFMode ? 'pdf' : '',
          noticeSort: this.currNoticeSort.join(','),
          multiFilename: this.getFilesName,
          multiFilepath: this.getFilesUrl,
          qywxSend: this.sendQywx ? 1 : 0,
          qywxCover: this.qywxFengmian
        });
        if (resp.data.status) {
            loading.close();
          this.$notify({
            group: 'global',
            title: "温馨提示",
            text: resp.data.msg,
          });
          Bus.$emit("noticeChange", {});
          this.resetForm();
          this.close();
        } else {
          this.$notify({
            group: 'global',
            title: '网络错误',
          });
        }

      },

      getTypeIdByPublishFor() {
        switch (parseInt(this.publishFor)) {
          case 0:
            return 1
          case 1:
            return 2
          case 2:
            return 0
          case 3:
            return 3
          default:
            console.log('publishFor值异常：', this.publishFor)
        }
      },
      //加载部门
      async initDepts() {
        let depts = await axios.post(apiConfig.REQUEST_URL + "/shall/f_getOrganizationList");
        depts = depts.data.data;

        function addId(depts) {
          for (let i = 0; i < depts.length; i++) {
            depts[i].id = depts[i].deptId
            depts[i].label = depts[i].deptName
            if (depts[i].children.length) {
              depts[i].children = addId(depts[i].children)
            }
          }
          return depts
        }

        depts = addId(depts)

        this.treeData = depts;
      },
      toggleSelectState(people) {
        if (this.selectPeople.indexOf(people.loginName) == -1) {
          this.selectPeople.push(people.loginName);
        } else {
          this.selectPeople.remove(people.loginName)
        }

      },
      checkDeptAction(currNode, currState) {
        let checkArr = this.$refs.deptTree.getCheckedNodes()
        this.checkedIds = checkArr.map(item => item.id)
        this.initPeople()
      },
      //加载人
      async initPeople() {
        this.canRequestPeople = false
        let peopleInfo = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getUserList?" + this.$qs.stringify({
          orgid: this.checkedIds.join(','),
          pageSize: this.peoplePageSize,
          pageNumber: this.peoplePageIndex ? this.peoplePageIndex : 1,
          property: '',
          keyword: this.peopleKeyword
        }));
        peopleInfo = peopleInfo.data.data[0];
        if (!peopleInfo) {
          this.peopleCount = 0;
          this.peoplePageIndex = 0;
          this.peopleList = [];
          this.canRequestPeople = true;
          return;
        }
        this.peopleCount = peopleInfo.totalCount;
        this.peoplePageIndex = peopleInfo.pageNumber;
        this.peopleList = peopleInfo.list;
        this.canRequestPeople = true;
      },
      clearSelectPeople() {
        this.selectPeople = [];
      },
      async handle() {
        console.log(123123)
      },
      peoplePageChange(pageIndex) {
        this.peoplePageIndex = pageIndex;
        this.initPeople();
      },
      peoplePageSizeChange(newPageSize) {
        this.peoplePageIndex = 1;
        this.peoplePageSize = newPageSize;
        this.initPeople();
      },
      uploadAction() {
        this.$refs.uploadBtn.click()
      },
      //上传请求
      uploadRequestBack(fileObj) {
        let promise = new Promise(async (resolve, reject) => {
          let uploadResult = await axios.post(apiConfig.REQUEST_URL + '/shall/front_uploadAttachment?' + this.$qs.stringify({
            filename: fileObj.name
          }), this.$qs.stringify({file: fileObj.content}), {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
          })
          if (!uploadResult.data.status) {
            reject()
          }
          let obj = {
            url: uploadResult.data.url + uploadResult.data.data[0].filepath,
            name: uploadResult.data.data[0].filename
          }
          resolve(obj)
        })
        return promise
      },
      uploadRequest(fileObj) {
        let promise = new Promise(async (resolve, reject) => {
          let uploadResult = await axios.post(apiConfig.REQUEST_URL + '/shall/front_upload', fileObj, {
            headers: {'Content-Type': 'application/x-www-form-urlencoded'}
          })
          if (!uploadResult.data.status) {
            reject()
          }
          let obj = {
            url: uploadResult.data.url + uploadResult.data.data[0],
            name: uploadResult.data.data[1]
          }
          resolve(obj)
        })
        return promise
      },
      getUploadFormDataByEvent(ev) {
        let binFile = ev.srcElement.files[0]
        let fileName = binFile.name

        let formData = new FormData();
        formData.append('file', binFile)
        return formData
      },
      //通过event对象去读取文件
      readFileByEvent(ev, cb) {
        let inputFile = ev.target
        let filereader = new FileReader();
        let fileType = inputFile.files[0].type || 'unknow';
        let fileName = inputFile.files[0].name;
        filereader.readAsDataURL(inputFile.files[0])
        filereader.addEventListener('load', (fileReaderEvent) => {
          cb.call(this, fileReaderEvent, fileType, fileName)
        })
      },
      async selectFile(ev) {
        let formData = this.getUploadFormDataByEvent(ev)
        let targetFiles = await this.uploadRequest(formData)
        this.filesList.push(targetFiles)
      },
      deleteFile(file) {
        this.filesList = _.remove(this.filesList, (item, key) => {
          return item !== file
        })
        this.filesList.sort()
      },

      //读取标签列表
      async fetchLabelList() {
        let labelList = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getLabelList')
        if (!labelList.data.status) {
          return false
        }
        this.labelList = labelList.data.data
      },

      //设置标签选择状态
      toggleSelectLabelState(item) {
        if (this.selectLabelList.indexOf(item.tagid) > -1) {
          this.selectLabelList = _.remove(this.selectLabelList, (selectItemId, key) => {
            return selectItemId !== item.tagid
          })
          return
        }
        this.selectLabelList.push(item.tagid)
      },
      //=========PDF相关===============
      togglePreviewPDFMode() {
        this.previewPDFMode = !this.previewPDFMode
      },
      toggleSendQywx() {
        this.sendQywx = !this.sendQywx
      },
      uploadPDFAction() {
        this.$refs.uploadPDFBtn.click()
      },
      async selectPDF(ev) {
        let formData = this.getUploadFormDataByEvent(ev)
        let fileInfo = await this.uploadRequest(formData)
        this.previewPDFInfo.name = ev.srcElement.files[0].name
        this.previewPDFInfo.url = fileInfo.url
      },
      async selectQywxFMImg(ev) {
        let formData = this.getUploadFormDataByEvent(ev)
        let fileInfo = await this.uploadRequest(formData)
        this.qywxFengmian = fileInfo.url
      },
      removeQywxFMImg() {
        this.qywxFengmian = null
      },
      resetPDFFile() {
        this.previewPDFInfo.name = null
        this.previewPDFInfo.content = null
      },
      async initNoticeSort() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getNoticeColumnList')
        if (resp.data.status !== 1) {
          return
        }
        console.log(resp);
        this.noticeColumn = resp.data.data.filter(item => {
          return this.userInfo.extend.noticeSortList.indexOf(item.noticeSort) > -1
        })
      },
      async fetchQywxTagList() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getQywxTagList')
        if (resp.data.status !== 1) {
          return
        }
        this.labelList = resp.data.data
      }
    },
    computed: {
      ...mapState(['systemList', 'modalOffsetDistance', 'userInfo']),
      getFileIds() {
        return this.filesList.map(item => {
          return item.id
        }).join(',')
      },
      getLabelToString() {
        let labelString = this.selectLabelList.join(',')
        return labelString
      },
      getFilesName() {
        return this.filesList.map(item => item.name).join(',')
      },
      getFilesUrl() {
        return this.filesList.map(item => item.url).join(',')
      },
    },
    watch: {},
    mounted() {
      this.initNoticeSort()
      this.fetchQywxTagList()
      this.fetchLabelList()
    },
    filters: {},
    components: {multiselect, flatPickr, editor}
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .content
    setPositionFull()
    padding 0 28px
    padding-bottom 100px
    overflow-y scroll !important

    .icon-duoxuankuang
      color themeColor

    .fdblock
      margin-top 20px

      &.selectNoticeSort
        & >>> .el-select
          .el-input__inner
            width 360px
            border-radius 5px

      & > p:first-of-type
        font-size 14px
        color #444444
        line-height 40px
        padding-left 10px
        position relative
        margin-bottom 10px

        &::after
          content: "";
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          background-color: themeColor;
          width: 2px;
          height: 16px;

        .checkbox
          margin-top -3px
          vertical-align middle
          margin-right 5px

      & >>> .wangEditor-container
        width auto
        overflow hidden
        border-radius 5px

      & >>> .flatpickr-input
        width 266px
        height 30px
        line-height 30px
        font-size 14px
        color #666666
        border 1px solid #cccccc
        border-radius 5px
        text-align center

      & >>> .vue-tree-item
        color #666
        font-size 14px

        .item-toggle
          position relative

      .linkway
        width 360px
        height 30px
        border-radius 5px
        padding 0 1em
        font-size 12px
        color #666666
        border 1px solid #cccccc

      .selectPublishFor
        margin-top 25px
        font-size 14px
        color #666666

        label
          margin-right 20px

          input
            margin-right 10px
            vertical-align middle

      .selectInfo
        /*border 1px solid #0f0*/
        padding-left: 1em;
        font-size 14px
        color #666666
        display inline-block
        margin-bottom 15px

        .clearbtn
          margin-left 10px
          background-color #ffffff
          padding 5px 10px
          border 1px solid themeColor
          outline none
          font-size 12px
          color themeColor
          border-radius 5px
          transition 300ms

          &:hover
            background-color #eeeeee

      .search
        border 1px solid #cccccc
        width 260px
        height 26px
        overflow hidden
        border-radius 5px
        font-size 14px
        color #666666
        margin-bottom 15px

        input
          padding-left 1em
          width 200px
          line-height 26px
          height 100%

        button
          float right
          width 50px
          height 100%
          background-color #eeeeee
          border none
          outline none

      .peopleList
        margin-bottom 10px

        &::after
          content ""
          display block
          width 100%
          clear both

        li
          font-size 14px
          display inline-block
          float left
          padding 10px
          min-width 100px
          margin-right 10px
          margin-bottom 10px
          text-align center
          color #666666
          position relative
          box-shadow 1px 1px 4px #cccccc
          cursor pointer
          transition 300ms

          &:hover
            box-shadow 1px 1px 8px #cccccc

          & > span
            position absolute
            right 1px
            top 1px

            i
              color themeColor
              font-size 10px


      .inputBtn
        display inline-block
        border 1px solid #cccccc
        width 260px
        border-radius 5px
        overflow hidden
        position relative

        .btn
          color #666666
          position absolute
          left 0
          right 0
          top 0
          bottom 0
          background-color #ffffff
          line-height 28px
          text-align center
          transition 300ms
          cursor pointer

          &:hover
            background-color #f1f1f1

      .fileList
        li
          border 1px solid #cccccc
          width 260px
          height 32px
          margin-top 10px
          font-size 14px
          line-height 32px
          padding 0 10px
          border-radius 5px
          display inline-block
          color #666
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
          margin-right 10px
          position relative

          p
            display inline-block
            width 180px
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            vertical-align middle

          /*vertical-align middle*/

          .del
            position absolute
            right 0
            top 0
            bottom 0
            width 30px
            text-align center
            line-height 30px
            color #999999

            i.iconfont
              font-size 20px

            &:hover
              color #333333

          & > i.iconfont
            vertical-align middle
            margin-right 5px
            display inline-block
            font-size 20px

    &.selectPDFViewMode
      p
        vertical-align middle

        i.iconfont
          color themeColor
          text-shadow 1px 1px 2px rgba(0, 74, 148, 0.43)
          vertical-align middle

  .submitBtn
    font-size 12px
    border-radius 5px
    margin-top 40px
    margin-right 20px
    border 1px solid themeColor
    color themeColor
    background none
    outline none
    width 100px
    height 30px
    transition 300ms

    &:hover
      background-color #eeeeee


</style>



// WEBPACK FOOTER //
// src/components/notice/createNoticeModal.vue